import sweealert2 from 'sweetalert2'
const swal = {}

swal.install = (Vue) =>{
    Vue.prototype.$swal =sweealert2
}
export default swal;